import { API_PREFIX, type HttpClient } from "@nasam/kernel";
import type { TenantRepository } from "../domain";
import {
  tenantBrandingResponseDtoSchema,
  tenantResolveResponseDtoSchema,
} from "./tenantDtos";
import { tenantBrandingFromDto, tenantIdentityFromDto } from "./tenantMappers";

const TENANTS_PATH = `${API_PREFIX}/tenants`;

export function createHttpTenantRepository(http: HttpClient): TenantRepository {
  return {
    async getBranding() {
      // Public: must resolve before login, so the login screen can be
      // branded. The backend infers the tenant from the Origin header the
      // browser already sends — no query param, no path segment.
      const response = await http.get(`${TENANTS_PATH}/branding`, {
        skipAuth: true,
      });
      return tenantBrandingFromDto(
        tenantBrandingResponseDtoSchema.parse(response).data,
      );
    },
    async resolve() {
      // Public, same Origin-inference as every other tenant call. A 404
      // here (no workspace at this address) is a normal outcome for the
      // caller to branch on, not a transport failure to retry.
      const response = await http.get(`${TENANTS_PATH}/resolve`, {
        skipAuth: true,
      });
      return tenantIdentityFromDto(
        tenantResolveResponseDtoSchema.parse(response).data,
      );
    },
  };
}
